var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,1.9l48.7,80.5C84.7,93.1,67.6,98.9,50,99c-17.6-0.1-34.7-6-48.7-16.7L50,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,100c-17.8-0.1-35.1-6-49.2-16.8L0,82.6l0.5-0.9L50,0l50,82.6l-0.8,0.6C85.1,94,67.8,99.9,50,100z M2.6,82 C16.3,92.2,32.9,97.8,50,97.8c17.1,0,33.7-5.6,47.3-15.8L50,3.7L2.6,82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO03);
export default __webpack_public_path__ + "static/media/O_03.fcc10cef0283bff394a1f3396bf691cd.svg";
export { ForwardRef as ReactComponent };